import React, {useState} from 'react';
//material
import {
  Card,
  CardContent,
  withStyles,
  Collapse,
  IconButton,
  Grid
} from '@material-ui/core';
import {Phone, Email, Language, ExpandMore} from '@material-ui/icons';
//styles
import styles from './club-card-styles';

const ClubCardView = (props) => {
  const {classes, club, address} = props;
  const [expanded, setExpanded] = useState(false);

  const parseHtml = html => new DOMParser().parseFromString(html, 'text/html').body.innerText;

  return (
    <Card>
      <CardContent className={classes.cardContent}>
        <div className={classes.title}>
          Golf Club
        </div>

        <IconButton
          className={classes.expandButton + ' ' + (expanded ? classes.expandOpen : '')}
          onClick={() => setExpanded(!expanded)}
          size={'small'}>
          <ExpandMore />
        </IconButton>

        <Collapse in={expanded} timeout='auto' unmountOnExit>
          <Grid container className={classes.gridContainer}>
            {
              (club) &&
              <Grid item xs={12} md={8}>
                <iframe className='otc-club-map'
                        style={{width: '100%', height: 300}}
                        src={parseHtml('https://maps.google.com/maps?q=' + encodeURI(JSON.stringify(club.name)) + '&amp;t=m&amp;z=14&amp;output=embed&amp;iwloc=near')}
                        frameBorder='0' marginWidth='0' marginHeight='0' scrolling='no'
                        aria-label={JSON.stringify(club.name)}/>
              </Grid>
            }

            {
              (club) &&
              <Grid item xs={12} md={4}>
                <div className={classes.clubDetails}>
                  <div className={classes.clubName}>
                    {club.name}
                  </div>

                  <div className={classes.subheader + ' ' + classes.addressPart}>
                    {address.line1}
                  </div>

                  <div className={classes.subheader + ' ' + classes.addressPart}>
                    {address.line2}
                  </div>

                  <div className={classes.subheader + ' ' + classes.addressPart}>
                    {address.town}
                  </div>

                  <div className={classes.subheader + ' ' + classes.addressPart}>
                    {address.county}
                  </div>

                  <div className={classes.subheader}>
                    {address.postCode}
                  </div>
                </div>

                <table>
                  <tbody>
                  {
                    club.phoneNumber &&
                    <tr>
                      <td className={classes.clubIcon}><Phone className={classes.icon} /></td>
                      <td className={classes.clubText}><a href={'tel:' + club.phoneNumber}>{club.phoneNumber}</a></td>
                    </tr>
                  }

                  {
                    club.emailAddress &&
                    <tr>
                      <td className={classes.clubIcon}><Email className={classes.icon} /></td>
                      <td className={classes.clubText}><a href={'mailto:' + club.emailAddress}>{club.emailAddress}</a></td>
                    </tr>
                  }

                  {
                    club.websiteUrl &&
                    <tr>
                      <td className={classes.clubIcon}><Language className={classes.icon} /></td>
                      <td className={classes.clubText}><a href={(club.websiteUrl.includes('http') ? '' : '//') + club.websiteUrl} target={'_blank'} rel={'noopener'}>{club.websiteUrl}</a></td>
                    </tr>
                  }
                  </tbody>
                </table>

              </Grid>
            }
          </Grid>

        </Collapse>
      </CardContent>
    </Card>
  );
};

export default withStyles(styles) (ClubCardView);
